import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Lead} from "../../models/lead.model";
import {User} from "../../models/user.model";
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {LeadService} from "../../providers/lead.service";
import {Subscription} from "rxjs";
import {Router} from "@angular/router";

@Component({
  selector: 'app-lead-agreement',
  templateUrl: './lead-agreement.component.html',
  styleUrls: ['./lead-agreement.component.scss'],
})
export class LeadAgreementComponent implements OnInit, OnDestroy {

  private isBusy: boolean;
  private isBusySub: Subscription;

  @Input() lead: Lead;
  @Input() loggedUser: User;
  @Output() agreementAcceptedEmitter: EventEmitter<Lead> = new EventEmitter<Lead>();
  @Output() agreementCancelEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  isAccepted: boolean;
  finallyAccept: boolean;
  isCancelled: boolean;


  private hasUnsavedChanges: boolean = false;


  constructor(
    private leadService: LeadService,
    public commonUtils : CommonUtils,
    private modalController: ModalController,
    private appStateService: AppStateService,
    private router: Router
  ) {
  }

  ngOnInit() {
    console.log(this.lead);
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });
    this.isAccepted = false;
    this.finallyAccept = false;
    this.isCancelled = false;
  }

  onToggleAccept() {
    this.isAccepted = !this.isAccepted;
  }

  onAcceptButton() {
    this.appStateService.updateIsBusySubject(true);
    this.leadService.acceptLead(this.lead).subscribe(leadAccepted => {
      if (leadAccepted && leadAccepted.uuid) {
        console.log(leadAccepted);
        this.lead = leadAccepted
        this.finallyAccept = true;
        this.appStateService.updateIsBusySubject(false);
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas akceptacji');
        this.appStateService.updateIsBusySubject(false);
      }
    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas akceptacji');
      this.appStateService.updateIsBusySubject(false);
    });
  }

  ngOnDestroy() {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  close() {
    this.appStateService.updateIsBusySubject(true);
    if (this.isCancelled) {
      this.agreementCancelEmitter.emit(true);
      this.router.navigate(['home'])
    } else {
      this.agreementAcceptedEmitter.emit(this.lead);
      this.router.navigate(['home'])
    }
  }

  cancel() {
    this.isCancelled = true;
  }
}
